import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAppContext } from "../../contexts/AppContext";
import { Spinner } from "react-bootstrap";

const LearningPlans = ({
  languages,
  handleSelectedPlan,
  validationATV3Loading,
}) => {
  const [loading, setLoading] = useState(false);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const { currentUser } = useAppContext();
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const trainingPrograms = await getTrainingPrograms();

      if (!currentUser.isPowerUser && currentUser.activeTrainingRequirement) {
        let userTrainingProgram = trainingPrograms.trainingPrograms.filter(
          (tp) => tp.trainingName == currentUser.activeTrainingRequirement
        )[0];

        if (!userTrainingProgram || userTrainingProgram === "") {
          getLearningPlans();
        } else {
          getLearningPlans(userTrainingProgram.trainingCode);
        }
      } else {
        getLearningPlans();
      }
    })();
  }, []);

  const getTrainingPrograms = async () => {
    const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/course/trainingprograms${window.location.search}`,
        {}, { withCredentials: true }
    );
    const trainingProgramsJson = response.data;
    return trainingProgramsJson;
  };

  const getLearningPlans = async (query, page) => {
    setLoading(true);
    const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/learningplan/learningplan${window.location.search}`,
      {
        user_id: 0,
        username: "",
        auth_code: "",
        hash: "",
        sortAttr: "name",
        returnCourses: true,
        pageSize: 0,
          isAtv3Users: currentUser.AHCASEligible === 1 ? true : false,
          isPowerUser: currentUser.isPowerUser
        }, { withCredentials: true }
    );
      //currentUser.activeTrainingRequirement === "Continuing Education" ? false :
      if (query) {
          if (query === "CE-LP") {
              var plans = [...response?.data?.items];
              plans = plans
                  .filter((lp) => lp.code.endsWith(languages[0].languagecode))
                  .sort((x) => x.name);

              setFilteredPlans(plans);
          }
          else {
              const filteredItems = response?.data?.items.filter((item) =>
                  item.code.includes(query)
              );
              var plans = [...filteredItems];
              plans = plans
                  .filter((lp) => lp.code.endsWith(languages[0].languagecode))
                  .sort((x) => x.name);

              setFilteredPlans(plans);
          }
    } else {
      var plans = [...response?.data?.items];
      plans = plans
        .filter((lp) => lp.code.endsWith(languages[0].languagecode))
        .sort((x) => x.name);

      setFilteredPlans(plans);
    }
    setLoading(false);
  };

  const handleSelectedPlanClick = (plan) => {
    setLoadingPlanId(plan.id);
      const hasBt30ButNotAlta =
          typeof plan?.code === "string" &&
          plan.code.includes("BT30") &&
          !plan.code.includes("ALTABT-BT30");
      if (hasBt30ButNotAlta == true) {
          setLoadingPlanId(null);
      }

      handleSelectedPlan(plan, hasBt30ButNotAlta);
  };

  return (
    <div style={{ paddingTop: "10px" }}>
      {loading ? (
        <div className="container p-3 mt-3">
          <div className="row">
            <h6 className="text-center color-grey pt-5">
              <Spinner animation="border" />
            </h6>
          </div>
        </div>
      ) : filteredPlans.length > 0 ? (
        <div>
          {filteredPlans.map((plan) => (
            <div key={plan.id} className="learning-plans-container">
              <div className="learning-plans">
                <div className="learning-plan-heading">{plan.name}</div>
                <div className="learning-plan-description">
                  {plan.shortdescription
                    ? plan.shortdescription
                    : "No description available"}
                </div>
              </div>
              <div className="select-learning-plan-btn">
                <button
                   onClick={() => handleSelectedPlanClick(plan)}
                  className="button"
                  style={{ width: "150px" }}
                >
                  {validationATV3Loading && loadingPlanId === plan.id && (
                    <Spinner
                      className="me-1"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Select
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-learning-plans">No learning plans are available</div>
      )}
    </div>
  );
};

export default LearningPlans;
